import React from "react";

class SelectableTable extends React.Component {
    /*
     [{x1: v1, x2: v2, ...},
     ...
     ]
     */
    constructor(props) {
        super(props);

        this.name = props.name;
        this.onCheckChange = props.onCheckChange;
        this.inputType = props.inputType;
        this.excludedNames = props.excludedNames ? props.excludedNames : [];
    }

    componentDidMount() {}

    componentWillUnmount() {}

    createHeader = (data) => {
        let cols = [];
        for (let key in data) {
            if (!this.excludedNames.includes(key)) {
                cols.push(<th className="tsS">{key}</th>);
            }
        }

        cols.push(<th className="tsS">選択</th>);

        return <tr>{cols}</tr>;
    };

    createRow = (data, index) => {
        let cols = [];
        for (let key in data) {
            if (!this.excludedNames.includes(key)) {
                //TODO:文字列が表示されない場合があるので、10文字に切り詰める
                let s = `${data[key]}`;
                if (s.length > 10) {
                    s = s.slice(0, 10) + "...";
                }

                cols.push(<td key={`${key}-${index}`}>{s}</td>);
            }
        }

        cols.push(
            <td className="l-textCenter">
                <input
                    id={"select" + index}
                    type={this.inputType}
                    style={{ display: "block" }}
                    name={this.name}
                    value={index}
                    onChange={this.handleCheckChange}
                    defaultChecked={this.props.defaultCheckedList ? this.props.defaultCheckedList[index] : false}
                />
                <label htmlFor={"select" + index}></label>
            </td>,
        );

        return <tr key={index}>{cols}</tr>;
    };

    handleCheckChange = (e) => {
        //        this.props.onCheckChange(e.target.checked, e.target.value);
        this.onCheckChange(e.target.checked, e.target.value);
    };

    createRows = (dataList) => {
        return dataList.map((data, index) => this.createRow(data, index));
    };

    render() {
        if (this.props.dataList && this.props.dataList.length > 0) {
            return (
                <div style={{ height: "200px", position: "relative", overflow: "scroll" }}>
                    <table className="table">
                        <thead>{this.createHeader(this.props.dataList[0])}</thead>
                        <tbody>{this.createRows(this.props.dataList)}</tbody>
                    </table>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default SelectableTable;
